import React from 'react'
import './Submissionid_Check.scss';


class SubmissionidCheck extends React.Component {
    constructor(props) {
        super(props)
        this.initialVal = {
          id: '',
          isSubmitted: false,
        };
        this.state=this.initialVal;
        this.labelMapper={
          anticipatedProjectLength: 'Anticipated Project Length',
          basePremium: 'Base Premium',
          excessPremium: 'Excess Premium',
          excessTerrorPremium: 'Excess Terror Premium',
          extendedCompletedOpsPremium: 'Extended Products Completed Operation',
          identityRecoveryPremium: 'Identity Recovery Premium',
          instantQuote: 'Quote',
          hnoaPremium: 'HNOA',
          pollutionPremium: 'Hostile Fire Give Back',
          rate: 'Base Rate',
          subsidencePremium: 'Subsidence',
          terrorPremium: 'Terrorism',
          totalExcessPremium: 'Total Excess Premium',
          totalPremium: 'Total Premium',
          totalPrimaryPremium: 'Total Primary Premium',
          oeMinimumPremium: 'OE Minimum Premium',
          minimumEarnedPremium: 'Minimum Earned Premium',
          occurenceLimit: 'Occurence Limit',
          aggregateLimit: 'Aggregate Limit',
          completedOpsLimit: 'Completed Ops Limit',
          eachOccurrence: 'Each Occurence',
          generalAggregate: 'General Aggregate'
        };
      }
   clickHandler = (event) => {
            this.setState({
                          id: event.target.value,
                          message: ''
            })
        }
        submitSubmissionId = () => {
            this.props.handleSubmit(this.state.id)
            this.setState({
              isSubmitted: true,
            })
    }
      clearSubmissionId = () => {
          this.setState(this.initialVal);
          this.props.handleSubmit('');
        }
        render() {
    var ratings=this.props.ratings;
         var x=ratings;
         var i=Math.random *10;
      return (
              <div className="SubmissionICheck">
            <div className="search_input">
              <h4>Enter Submission Number</h4>
                <input type="text" value={this.state.id} onChange={this.clickHandler} className="search-input" placeholder="Submission id" />
            </div>
                <div className="btns">
                <button className="submit_button"onClick={this.submitSubmissionId} type="submit"> Submit </button>
                <button className="submit_button" onClick={this.clearSubmissionId} type="submit"> Clear </button>
                </div>
                <div className="err">
                {this.props.error && this.state.isSubmitted &&<h4>{this.props.err}</h4>}
                </div>
                <div className="rating_values">
              {Object.keys(ratings).map((key) => (
              <h4>{typeof ratings[key]!=='object'&&ratings[`${key}`]!==0 && (this.labelMapper[key] === 'Base Rate'&& ratings[`${key}`]==-1 ? `${this.labelMapper[key]}   :  Minimum Premium`: `${this.labelMapper[key]}   :   ${ratings[`${key}`]}`)}</h4>
           ))}
              {Object.keys(x, i).map(key1 => {
              if (typeof x[key1] === 'object') {
                 return Object.keys(x[key1]).map(key2 => {
                 return Object.keys((x[key1])[key2]).map(innerKey => {
                   return (
                   <div>
                    <h4>{`${this.labelMapper[innerKey]} : ${((x[key1])[key2])[innerKey]}`}</h4>
                   </div>
                    )
                    })
                  })
                }
                })}
                </div>
              </div>
                );
              }
            }
export default SubmissionidCheck

